import { createNetworkApi } from '@lib/util/networkRequest';

import apiInstance from '../instances/drupal';

export default createNetworkApi (apiInstance, {
  translatePath: (path) => ({
    method: 'get',
    url: `/router/translate-path?path=${path}`,
    transform: (result) => result
  })
})
